<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>{{type==0?'添加外部合伙人':'编辑外部合伙人'}}
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :rules="rules" :model="formdata" label-width="180px" id="recruitCompany">
          <el-form-item label="真实姓名" prop="name">
            <el-input type="text" v-model="formdata.name" placeholder="请输入名称" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="tel">
            <el-input type="text" v-model="formdata.tel" placeholder="请输入联系方式" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="充值金额" prop="balance" v-if="type==0">
            <el-input type="text" v-model="formdata.balance" placeholder="请填写金额" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="续充金额" prop="balance" v-if="type==1">
            <el-input type="text" v-model="formdata.balance" placeholder="请填写金额" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="是否可消费" prop="is_discount">
          <el-radio-group v-model="is_discount">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
          <el-form-item label="银行卡号" prop="bank_card">
            <el-input type="text" v-model="formdata.bank_card" placeholder="请填写卡号" class="w340"></el-input>
          </el-form-item>
           <el-form-item label="户名" prop="bank_username">
            <el-input type="text" v-model="formdata.bank_username" placeholder="请填写户名" class="w340"></el-input>
          </el-form-item>
           <el-form-item label="开户行" prop="bank_name">
            <el-input type="text" v-model="formdata.bank_name" placeholder="请填写开户行" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="到期时间" prop="expire_time">
            <el-date-picker v-model="formdata.expire_time" type="date" placeholder="请选择到期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item label="选择管家">
            <div class="goodsType">
                      <template v-if="activity.length>0">
                        <span v-for="item in activity" :key="item.keeper_id">
                          {{item.title}}
                        </span>                        
                      </template>  
                     <template v-else>
                       {{defaultName}}
                      </template>
            </div>
            <el-button size="small" @click="dialogActivity = true">选择管家</el-button>
          </el-form-item>
          
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formdata.remark" placeholder="请输入" class="w340"></el-input>
          </el-form-item>
          <el-form-item v-if="type==0">
            <el-button type="primary" @click="onGetQrcode">生成二维码</el-button>
            <el-button @click="goback">取消</el-button>
          </el-form-item>
          <el-form-item v-if="type==1">
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="goback">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <shenheDialog :visible.sync="dialogActivity" @updatePageInfo="updatePageInfo"></shenheDialog>
    
    <el-dialog
      title="二维码"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="text-align:center">
      <el-image
          style="width: 200px; height: 200px"
          :src="qrResult.qrcode"
          ></el-image>
      <p>请将二维码分享给[{{formdata.name}}]微信，进行授权绑定</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import shenheDialog from '@/components/tkdialog/shenheDialog';
  export default {
    name: "addextPartner",
    components: {
      shenheDialog
    },
    data() {
      return {
        formdata: {
          name: '',
          tel:'',
          balance: "",
          bank_card: "",
          bank_username: "",
          bank_name: "",
          expire_time: "",
          remark: "",
          eid: "",
          keeper_id: '',
          qrcode:'',
        },
        is_discount: 1,
        pageoption: this.$route.query,
        editInfo: '',
        qrResult: {},
        dialogVisible: false,
        dialogActivity: false,
        type: '',
        defaultName:'',
        activity : [],//员工列表
        rules: {
          name: [{required: true, message: "请输入姓名", trigger: "blur"}],
          tel: [{required: true, message: "请输入联系方式", trigger: "blur"}],
          balance: [{required: true, message: "请输入金额", trigger: "blur"}],
          bank_card: [{required: true, message: "请输入银行卡号", trigger: "blur"}],
          bank_username: [
            {required: true, message: "请输入户名", trigger: "blur"}
          ],
          bank_name: [
            {required: true, message: "请输入开户行", trigger: "blur"}
          ],
          expire_time: [
            {required: true, message: "请输入到期时间", trigger: "blur"}
          ]
        }
      };
    },
    created() {
      this.type = this.$route.query.type;
      this.InitFn()
    },
    
    methods: {
      InitFn() {
        if (this.pageoption.id) {
          this.axios
              .post(api.partner_detail, {partner_id: this.pageoption.id})
              .then(response => {
                if (response.data.code == 0) {
                  this.formdata = response.data.result;
                  this.defaultName = response.data.result.keeper_name;
                } else {
                }
              })
              .catch(response => {
              });
        }
      },
      goback() {
        this.$router.go(-1);
      },
      // 生成二维码
    onGetQrcode() {
      if (!this.formdata.balance) {
          this.$message.error('请填写金额');
          return
        }
        if (!this.formdata.bank_card) {
          this.$message.error('请填写卡号');
          return
        }
        if (!this.formdata.bank_username) {
          this.$message.error('请填写户名');
          return
        }
        if (!this.formdata.bank_name) {
          this.$message.error('请填写开户行');
          return
        }
        if (!this.formdata.expire_time) {
          this.$message.error('请选到期时间');
          return
        }

      let url_ = api.partnerAdd // role_edit
      let data_ = this.formdata
      data_.partner_id = this.pageoption.id
      let title = '生成二维码成功'
        // if (Number(this.pageoption.type) === 1) {
        //   url_ = api.partner_edit
        //   data_.partner_id = this.pageoption.id
        //   title = '编辑成功！'
        // }
        
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.qrResult = response.data.result;
                this.dialogVisible = true;
                this.defaultName = '';
                this.$message({
                  showClose: true,
                  message: title,
                  center: true
                });
                // this.$router.go(-1)
              } else {
              }
            })
            .catch(response => {
            });
    },
    onSubmit() {
      let data_ = this.formdata
      let title = '编辑成功！' // type_ 0 添加 1 编辑
      let url_ = api.partner_edit
      data_.partner_id = this.pageoption.id
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.defaultName = '';
                this.$message({
                  showClose: true,
                  message: title,
                  center: true
                });
                this.$router.go(-1)
              } else {
              }
            })
            .catch(response => {
            });
    },
    updatePageInfo(option) {
      this.activity = option;
      let arr = [];
      for (let i = 0; i < option.length; i++) {
        arr.push(option[i].id);
      }
      // this.formdata.eid = arr.join(',');
      this.formdata.keeper_id = arr[0];
    },
    onChange(e) {
      this.formdata.keeper_id = e;
    },

    }
  };
</script>
<style>
  #recruitCompany .el-form-item{
    margin-bottom: 22px;
  }
</style>

